import React from 'react';
import {MdTextField} from 'core/components/fields/fields';
import {createForm} from 'core/form/createForm';
import {FormProps, lovValue, formatValue, lovLabel} from 'core/form/formUtils';
import StyledSelect from 'core/components/fields/styledSelect';
import NumberField from 'core/components/fields/numberField';
import {BlockComp} from 'core/components/blockComp/blockComp';
import ActiveItem from 'core/components/blockComp/activeItem';
import {Validate} from 'core/form/validate';
import {optionsSearch} from "core/common/service/commonDataService";
import StyledDateInterval from "core/components/fields/styledDateInterval";
import {formatInterval} from "core/common/utils/dateUtils";
import {PRICECOMPLEVEL_COLORS, PriceComponent} from "product/productDomain";
import {observer} from "mobx-react";
import {PARTYROLE} from "party/partyDomain";
import {DefinitionType, FIELDDEFDISPLAYTYPE} from "core/form/form";
import Lens from "material-ui/svg-icons/image/lens";
import RadioButtonField from "core/components/fields/radioButtonField";
import {grey400} from "material-ui/styles/colors";
import {ClosedFormBlock, ClosedFormBlockProps, ClosedFormField} from "core/form/closedForm";


@observer
class PriceComponentForm extends React.Component<FormProps<PriceComponent, PriceComponent>, undefined> {


  render() {

    let {dataObject, rootObject, entities, entity, formName} = this.props;
    let fields = dataObject.getFormFields(formName);
    let {priceLevel, price, priceCurrency, priceLcy, comment, validFrom, validTo, product, profitCenter, vehicle, party} = fields;


    console.debug('PriceComponentForm render');

    let openContent = (
      <div>

        {/*  2. row  */}
        <div className="row">
          <div className="col-xs-12">
            <div style={{color: grey400, marginBottom: 5}}>{priceLevel.mdField.formLabelActive}</div>
            <RadioButtonField {...priceLevel.props} groupStyle={{display: 'flex'}}
                              optionStyle={{width: 'initial', marginRight: 15}}
                              labelStyle={{whiteSpace: 'nowrap', marginLeft: -10}}
                              iconStyleFn={v => ({fill: PRICECOMPLEVEL_COLORS[v]})}/>
            <Validate field={priceLevel} value={priceLevel.props.value}/>
          </div>
        </div>

        <div className="row">
          <div className="fx col-xs-12 col-sm-6">
            <StyledSelect {...product.props} async loadOptions={optionsSearch.bind(this, 'Product', {})} clearable
                          asterixForAll/>
            <Validate field={product} value={product.props.value}/>
          </div>
          <div className="fx col-xs-12 col-sm-6">
            <StyledSelect  {...vehicle.props} async loadOptions={optionsSearch.bind(this, 'Vehicle', {})} clearable/>
          </div>
          <div className="fx col-xs-12">
            <StyledSelect  {...party.props} async
                           loadOptions={optionsSearch.bind(this, 'Party', {role: [PARTYROLE.CUSTOMER_ROLE]})}
                           clearable/>
          </div>
        </div>


        <div className="row">
          <div className="fx col-xs-6 col-sm-3">
            <NumberField {...price.props} />
            <Validate field={price} value={price.props.value}/>
          </div>
          <div className="fx col-xs-6 col-sm-3">
            <StyledSelect {...priceCurrency.props} />
            <Validate field={priceCurrency} value={priceCurrency.props.value}/>
          </div>
          <div className="fx col-xs-6 col-sm-3">
            <NumberField {...priceLcy.props} />
            <Validate field={priceLcy} value={priceLcy.props.value}/>
          </div>
          <div className="fx col-xs-6 col-sm-3">
            <StyledSelect {...profitCenter.props} />
            <Validate field={profitCenter} value={profitCenter.props.value}/>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-sm-4">
            <StyledDateInterval {...validFrom.props} valueFrom={validFrom.props.value} valueTo={validTo.props.value}
                                onChangeFrom={validFrom.props.onChange} onChangeTo={validTo.props.onChange}/>
          </div>
        </div>

        <div className="row">
          <div className="fx col-xs-12">
            <MdTextField {...comment.props} multiLine={true} rows={3}/>
          </div>
        </div>

      </div>
    );

    return (
      <BlockComp noPadding>
        <ActiveItem openContent={openContent}
                    closedContent={<ClosedContent {...{dataObject, entity, entities, fields}} />}
                    validate={this.props.validate} {...this.props} />
      </BlockComp>
    );
  }
}

const ClosedContent = ({dataObject, entity, entities, fields, disabled}: ClosedFormBlockProps<PriceComponent>) => (
  <div style={{display: 'flex'}}>
    <div style={{marginRight: 5}}>
      <Lens style={{color: PRICECOMPLEVEL_COLORS[lovValue(dataObject.priceLevel)]}}/>
    </div>

    <ClosedFormBlock {...{dataObject, entity, entities, fields}} >
        <ClosedFormField label={fields.priceLevel.textLabel} value={dataObject.priceLevel}/>
        <ClosedFormField label={fields.product.textLabel} value={dataObject.product}
                   linkProps={{to: 'productDetail', params: {id: lovValue(dataObject.product)}}}/>
        <ClosedFormField label={fields.vehicle.textLabel} value={dataObject.vehicle}
                   linkProps={{to: 'vehicleDetail', params: {id: lovValue(dataObject.vehicle)}}}/>
        <ClosedFormField label={fields.party.textLabel} value={dataObject.party}
                   linkProps={{to: 'partyDetail', params: {id: lovValue(dataObject.party)}}}/>
        <ClosedFormField label={fields.price.textLabel}>
          <span>{formatValue(dataObject.price, fields.price.mdField) + ' ' + lovLabel(dataObject.priceCurrency)}</span>
        </ClosedFormField>
        <ClosedFormField label={fields.priceLcy.textLabel} value={dataObject.priceLcy} mdField={fields.priceLcy.mdField}/>
        <ClosedFormField label={fields.profitCenter.textLabel} value={dataObject.profitCenter}/>
        <ClosedFormField label={fields.validFrom.textLabel} value={formatInterval(dataObject.validFrom, dataObject.validTo)}/>
        <ClosedFormField label={fields.comment.textLabel} value={dataObject.comment}/>
    </ClosedFormBlock>

  </div>

);

const definition: DefinitionType = {
  formName: 'PriceComponentForm',
  fields: [{
    name: 'priceLevel',
    displayType: FIELDDEFDISPLAYTYPE.radioButton,
    validators: ['IsRequired']
  }, {
    name: 'price',
    validators: ['IsRequired', 'IsNumber']
  }, {
    name: 'priceCurrency',
    validators: ['IsRequired']
  }, {
    name: 'priceLcy',
    validators: ['IsNumber']
  }, {
    name: 'comment',
    displayType: FIELDDEFDISPLAYTYPE.textArea
  }, {
    name: 'validFrom'
  }, {
    name: 'validTo'
  }, {
    name: 'product',
    validators: ['IsRequired']
  }, {
    name: 'profitCenter'
  }, {
    name: 'vehicle'
  }, {
    name: 'party'
  }]
};

export default createForm(definition, ClosedContent)(PriceComponentForm);




// WEBPACK FOOTER //
// ./src/product/component/priceComponentForm.tsx